module.exports = __webpack_public_path__ + "img/communication8.930e7cae.png";